import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

const iconProps = {
    size: "xs" as const,
    color: colorsPalettes.carbon[200],
};

export type InfoItemProps = {
    icon: React.ComponentType<typeof iconProps>;
    title: string;
    tooltip: string;
};

export const InfoItem = ({ icon: IconComponent, title, tooltip }: InfoItemProps) => (
    <Tooltip content={tooltip}>
        <Flex
            gap="4px"
            alignItems="center"
            color={colorsPalettes.carbon[200]}
        >
            <IconComponent {...iconProps} />
            <Text
                fontVariant="caption"
                color={colorsPalettes.carbon[400]}
            >
                {title}
            </Text>
        </Flex>
    </Tooltip>
);
